"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.go = void 0;
const isClient = typeof window === 'object';
exports.go = isClient
    ? (page, { replace, title, state } = {}) => {
        replace ? history.replaceState(state, title || '', page) : history.pushState(state, title || '', page);
    }
    : (() => { });
